import { ErrorPage } from '@aspendental/shared-components-web';
import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import getConfigByBrand from './utils/get-config-by-brand';
import { AppConfigByAppNameDocument } from '@src/lib/__generated/contentful/sdk';
import { client, previewClient } from '@src/lib/client';
import { getServerSideTranslations } from '@src/pages/utils/get-serverside-translations';
import { TagThemeType } from 'types/tag';
const ErrorPage404 = () => {
  const router = useRouter();
  useEffect(() => {
    //TODO: Figure out the theme and environment name for 404 page
  }, [router.asPath]);
  return <>
			<ErrorPage backgroundImageUrl="https://images.ctfassets.net/m8zwsu9tyucg/4abhlVjjHwioqizoLjI6aX/f0fa7d150eb0af91f85e7e56e8c9eed7/404_Image_-_Desktop.png?q=90&fit=fill&f=face&fm=webp" backgroundImageUrlMobile="https://images.ctfassets.net/m8zwsu9tyucg/bHvdZSVt0Y1mv9J6GJxwN/f587f276d64c49567c8dc3d09d421de4/404_Image_-_Mobile.png?q=90&fit=fill&f=face&fm=webp" body="Let's guide you back to the information you need." buttonLabel="Return to Home" heading="Oops!" subtitle="The page you're looking for seems to be missing." darkTextColor={false} data-sentry-element="ErrorPage" data-sentry-source-file="404.page.tsx" />
		</>;
};
export const getStaticProps: GetStaticProps = (async ({
  locale,
  preview = false
}) => {
  try {
    // Priority: HTTP header x-tag-theme > domain > process.env.TAG_BRAND_THEME
    const tagTheme = (process.env.TAG_BRAND_THEME || 'clearchoice') as TagThemeType;
    const brandConfig = getConfigByBrand(tagTheme);
    const gqlClient = preview ? previewClient : client;
    const appName = brandConfig.contentfulAppId || process.env.TAG_APP_NAME || 'TAG_Commercial_Web_Sandbox';
    const confirmationStepId = process.env.ENVIRONMENT_NAME === 'prod' ? brandConfig.features.confirmationStepId.prod : brandConfig.features.confirmationStepId.stage;
    const appConfig = await gqlClient.query(AppConfigByAppNameDocument, {
      appName,
      preview,
      confirmationStepId
    }).toPromise();
    const appData = appConfig.data.appCollection?.items[0];
    // TODO: remove this when we have a better way to get runtime environment name for static pages
    // The following way of getting environment name is not reliable because it depends on the build time.
    // Most likely that staging environment would be recognized as production for the 404 pages.
    const env = {
      ENVIRONMENT_NAME: process.env.NODE_ENV === 'production' ? 'prod' : 'stage'
    };
    // replace [env] with environment name for locationBarFindOfficeUrl
    // TODO: create a brand variable context to replace those variables from CMS in future
    if (appData && appData.header?.locationBarFindOfficeUrl) {
      const brandSubdomain = env?.ENVIRONMENT_NAME !== 'prod' ? 'wwwstg' : 'www';
      appData.header.locationBarFindOfficeUrl = appData.header?.locationBarFindOfficeUrl?.replace('[env]', brandSubdomain);
    }
    if (!appData) {
      throw new Error('App data not found');
    }
    return {
      props: {
        ...(await getServerSideTranslations(locale)),
        env,
        config: brandConfig,
        preview,
        appData,
        footerData: appData?.footer
      }
    };
  } catch {
    return {
      props: {
        ...(await getServerSideTranslations(locale)),
        preview,
        appData: null,
        footerData: null
      }
    };
  }
}) satisfies GetStaticProps;
export default ErrorPage404;